export const IsPrimaryContact: string = 'is_primary_contact';
export const Email: string = 'email';
